import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';
import {getSizedImageUrl} from '@shopify/theme-images';

import iconMinus from '../../../../assets/icon-minus.svg';
import iconPlus from '../../../../assets/icon-plus.svg';

const CartItem = ({item, customData, updateLineItems, isCartPage}) => {
  const isFreeGift = Boolean(item?.properties?._gwp) && item.final_line_price === 0;

  const itemComparePrice = customData.comparePrice ? customData.comparePrice * item.quantity : null;

  const imageSize = isCartPage ? '400' : '200';

  const canSaveToWishlist = !isFreeGift;

  const saveToWishlist = () => {
    if (window._swat?.addToWishList) {
      // Get wishlist product data
      const swymData = {
        et: window._swat.EventTypes.addToWishList,
        epi: item.variant_id,
        empi: item.product_id,
        uri: window.location.origin + item.url,
      };

      // Add to wishlist
      window._swat.addToWishList(swymData, function (e) {
        // Remove from cart
        updateLineItems({[item.key]: 0});

        // Show success message
        const successMessage = window.theme.strings.savedForLater.replace(
          '{{ title }}',
          `<strong>${item.product_title}</strong>`
        );
        window._swat.ui.showSuccessNotification({message: successMessage});
      });
    }
  };

  return (
    <li className={`cart-item ${isFreeGift ? 'cart-item--gwp' : ''}`}>
      <div className="cart-item__content-wrapper">
        {item.image && (
          <div className="cart-item__image">
            <a href={item.url}>
              <img loading="lazy" src={getSizedImageUrl(item.image, `${imageSize}x`)} alt={item.title} />
            </a>
          </div>
        )}
        <div className="cart-item__content">
          <div className="cart-item__content-group">
            <p className="cart-item__title">
              <strong>{item.product_title}</strong>
            </p>
            <p className="cart-item__description">
              <strong>{item.variant_title}</strong>
            </p>
          </div>
          {item.line_price > 0 && (
            <div className="cart-item__quantity-selector">
              <button onClick={() => updateLineItems({[item.key]: item.quantity - 1})} type="button">
                <span dangerouslySetInnerHTML={{__html: iconMinus}} />
              </button>
              <input
                id={`cart-qty_${item.key}`}
                type="number"
                name="quantity"
                min="1"
                aria-label={window.theme.strings.itemQuantity}
                value={item.quantity}
                autoComplete="off"
                onBlur={(event) =>
                  item.quantity === Number(event.target.value)
                    ? null
                    : updateLineItems({[item.key]: event.target.value})
                }
              />
              <button onClick={() => updateLineItems({[item.key]: item.quantity + 1})} type="button">
                <span dangerouslySetInnerHTML={{__html: iconPlus}} />
              </button>
            </div>
          )}
          {item.line_level_total_discount === 0 ? (
            <div className="cart-item__price-container">
              <strong
                className="cart-item__price"
                dangerouslySetInnerHTML={{__html: formatMoney(item.final_line_price, window.theme.moneyFormat)}}
              />

              {itemComparePrice && (
                <span
                  className="cart-item__price cart-item__price-original"
                  dangerouslySetInnerHTML={{__html: formatMoney(itemComparePrice, window.theme.moneyFormat)}}
                />
              )}
            </div>
          ) : (
            <div className="cart-item__price-container cart-item__price-container--discounted">
              <strong
                className="cart-item__price"
                dangerouslySetInnerHTML={{__html: formatMoney(item.final_line_price, window.theme.moneyFormat)}}
              />
              {itemComparePrice ? (
                <span
                  className="cart-item__price cart-item__price-original"
                  dangerouslySetInnerHTML={{__html: formatMoney(itemComparePrice, window.theme.moneyFormat)}}
                />
              ) : (
                <span
                  className="cart-item__price cart-item__price-original"
                  dangerouslySetInnerHTML={{__html: formatMoney(item.original_line_price, window.theme.moneyFormat)}}
                />
              )}
            </div>
          )}
          <button className="cart-item__remove btn-none" onClick={() => updateLineItems({[item.key]: 0})} type="button">
            <strong>{window.theme.strings.remove}</strong>
          </button>
          {canSaveToWishlist && (
            <button className="cart-item__wishlist-save btn-none" onClick={saveToWishlist} type="button">
              <strong className="hide--max-md">{window.theme.strings.save}</strong>
              <strong className="hide--min-md">{window.theme.strings.wishlist}</strong>
            </button>
          )}
        </div>
      </div>
      {item.properties && item.properties._bundle && item.properties._bundle_title && item.isValidBundle && (
        <div className="cart-item__donation">
          <p>{item.properties._bundle_title}</p>
        </div>
      )}
    </li>
  );
};

CartItem.propTypes = {
  item: PropTypes.object,
  customData: PropTypes.object,
  updateLineItems: PropTypes.func,
  isCartPage: PropTypes.bool,
};

export default CartItem;
